import { combineReducers, configureStore } from '@reduxjs/toolkit';

import { accountReducer } from './features/accountSlice.ts';
import { alertsReducer } from './features/alertsSlice.ts';
import { commentaryReducer } from './features/commentarySlice.ts';
import { featuresReducer } from './features/featuresSlice.ts';
import { orderReducer } from './features/orderSlice.ts';
import { priorSalesReducer } from './features/priorSalesSlice.ts';
import { propertyDataReducer } from './features/propertyDataSlice.ts';
import { reconciliationReducer } from './features/reconciliationSlice.ts';
import { referenceBarUIReducer } from './features/referenceBarUISlice.ts';
import { uiReducer } from './features/uiSlice.ts';
import { serializeAloftObjectMiddleware } from './serializeAloftObjectMiddleware.ts';
import { sortCompsMiddleware } from './sortCompsMiddleware.ts';
import { RootReducer } from './types.ts';

// combining reducers here instead of in configureStore to prevent a circular
// RootState reference with middleware (see
// https://redux.js.org/usage/usage-with-typescript#type-checking-middleware)
export const rootReducer: RootReducer = combineReducers({
  account: accountReducer,

  alerts: alertsReducer,
  order: orderReducer,
  commentary: commentaryReducer,
  priorSales: priorSalesReducer,
  reconciliation: reconciliationReducer,
  propertyData: propertyDataReducer,

  referenceBarUI: referenceBarUIReducer,
  ui: uiReducer,
  features: featuresReducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat([serializeAloftObjectMiddleware])
      .prepend(sortCompsMiddleware.middleware),
});
